$(document).ready(function ($) {



/*Account popup close*/
$(".js-account-pupup-close").click(function (e) {
  $(".js-account-pupup").hide();
})


  /*Collection slider*/
  $(".collection-slider").not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    asNavFor: ".collection-thumbnil-slider",
    adaptiveHeight: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 980,
      settings: {
        arrows: false,
      },
    }, ],
  });
  $(".collection-thumbnil-slider").not('.slick-initialized').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: ".collection-slider",
    dots: false,
    centerMode: false,
    infinite: false,
    focusOnSelect: true,
    verticalSwiping: true,
    vertical: true,
    variableWidth: false,
    responsive: [{
        breakpoint: 980,
        settings: {
          verticalSwiping: false,
          vertical: false,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          verticalSwiping: false,
          vertical: false,
          arrows: true,
        },
      },
    ],
  });
  var videoID;
  setTimeout(function(){  
  try{
  var id=$(".collection-thumbnil-slider li:first-child").attr("id").replace("slide","video");

  videoID =document.getElementById(id);

  videoID.play();
}
catch{}
}, 1000);
  $(".collection-thumbnil-slider li").click(function (e) {
try{

  videoID.pause();
}
catch{}
try{
  var id=$(this).attr("id").replace("slide","video");

  videoID =document.getElementById(id);

  videoID.play();
}
catch{}
  }
  )

  $(".collection-slider-section").show();

  /*$('.collection-slider').on('afterChange', function(event, slick, currentSlide){
   
   // $('.collection-slider').find(".slide-video").children("video").pause();
 
  var slide =$(this).find(".slick-current");
  if (slide.children("div").hasClass("slide-video")) {
   var vid=slide.children("div").children("video");
  // vid.play();
  
  }
})*/
   
        
          



  loadCustomCollection();
  
  
  /*resiter page dd change*/
  $(".js-customer-tag").change(function (e) {
  
    if($(".js-customer-tag").val()=="Authorized Island Stone Dealer")
    {
      $("#customer_tags").val('Pending Wholesale Account');
    }
    if($(".js-customer-tag").val()=="Designer or Architect")
    {
       $("#customer_tags").val('Designer or Architect');
    }
    if($(".js-customer-tag").val()=="Homeowner")
    {
       $("#customer_tags").val('Homeowner');
    }
  
  })
  
  
  /*Dealer login showing east west count*/
  
  setTimeout(function(){ 
  
  
   try {
     
  $("#inventory-info-app   .iia-list-item").each(function () {
     
     var inventoryType = $(this).find(".iia-title-text").children(".iia-location").html().toLowerCase();
        var inventoryCount = $(this).find(".iia-title-text").children(".iia-qty").html();
       
    if(inventoryType=="watsonville")
    {
      $(".js-product-inventory-west-coast").html(inventoryCount);
    }
    
     if(inventoryType=="parsippany")
    {
       $(".js-product-inventory-east-coast").html(inventoryCount);
    }
    
    
    $(".js-product-inventory").show();
        
    });
    
    }
       catch (err) {
       
       }
    
     }, 3000);
  
  /* 
  PRESS MEDIA
  */
  var months = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };
  var pressKeyMap = {};
  var pressMap = {};
  $(".js-press-accordion ul li").each(function () {
    // console.log("in Each ");
    var liElem = $(this);
    var dataTypeMonth = liElem.attr("data-type-month");
    var dataTypeYear = liElem.attr("data-type-year");
    // console.log(dataTypeMonth + "-" + dataTypeYear);
    var key = dataTypeYear + months[dataTypeMonth];
    if (!pressMap[key]) {
      pressKeyMap[key] = dataTypeMonth + " " + dataTypeYear;
      pressMap[key] = [];
    }
    pressMap[key].push(liElem);
    // console.log(pressMap);
    // console.log(pressMap.keys);
  });
  /* Print object in reverse order */
  //console.log(pressMap);
  //console.log(Object.keys(pressMap).reverse());
  var reversed = Object.keys(pressMap).reverse();
  $("ul.js-press-accordion").html("");
  $.each(reversed, function (key, opt) {
    var obj = pressMap[opt];
    // console.log(obj);
    // console.log(key);
    // console.log(opt);
    // console.log(pressMap);
    // console.log(pressKeyMap[opt]);
    var row =
      "<li><h4>" +
      pressKeyMap[opt] +
      '</h4><div class="accordion-content"><ul>';
    $.each(obj, function (i, o) {
      //console.log(o.get(0).outerHTML);
      row += o.get(0).outerHTML;
    });
    row += "</ul></div></li>";
    $("ul.js-press-accordion").append(row);
  });
  // add active class to the first li on page load
  $(".js-press-accordion li").first().addClass("active");
  /* Press Accordion Clicks */
  $(".js-press-accordion h4 ").click(function (e) {
    if (
      $(this).parent("li").children(".accordion-content").css("display") ==
      "none"
    ) {
      $(".js-press-accordion").children("li").removeClass("active");
      $(".js-press-accordion")
        .children("li")
        .children(".accordion-content")
        .slideUp();
      $(this).parent("li").children(".accordion-content").slideDown();
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").children(".accordion-content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  /* Resources and Inspiration - Some problem with IOS devices section height problem
  so added a new class for apple devices */
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isIOS) {
    $(".js-four-column-cta-with-bg-image-and-title").addClass("ios-device");
  }
  /* BLOG
Sidebar slide up and down working
*/
  $(".js-blog-sidebar")
    .children("ul")
    .children("li")
    .children("h4")
    .click(function (e) {
      if ($(this).parent("li").children("ul").css("display") == "none") {
        $(this).parent("li").parent("ul").children("li").removeClass("active");
        $(this)
          .parent("li")
          .parent("ul")
          .children("li")
          .children("ul")
          .slideUp();
        $(this).parent("li").children("ul").slideDown();
        $(this).parent("li").addClass("active");
      } else {
        $(this).parent("li").children("ul").slideUp();
        $(this).parent("li").removeClass("active");
      }
    });
  /*
  ABOUT
  Scroll to individual sections
  */
  $(".js-about-nav-list li").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var type = jQuery(this).children("a").attr("href");
    var pos = jQuery(type).offset().top - 60;
    $("body, html").animate({
      scrollTop: pos,
    });
  });
  /*
  ABOUT
  Open Team Pop Up
  */
  $(".showTeamPopup").click(function (e) {
    var name = $(this).parent("li").children("h4").html();
    var designation = $(this).parent("li").children(".designation").html();
    var location = $(this).parent("li").children(".location").html();
    var description = $(this).parent("li").children(".description").html();
    var url = $(this).parent("li").children(".url").html();
    var urlHref = $(this).parent("li").children(".url").attr("href");
    var image = $(this)
      .parent("li")
      .children(".image-section")
      .children("img")
      .attr("src");
    $(".teamPopup")
      .children(".contentSection")
      .children(".inner")
      .children(".imageBlock")
      .children(".image-wrapper")
      .children("img")
      .attr("src", image);
    $(".teamPopup")
      .children(".contentSection")
      .children(".inner")
      .children(".contentBlock")
      .children("h4")
      .html(name);
    $(".teamPopup")
      .children(".contentSection")
      .children(".inner")
      .children(".contentBlock")
      .children(".designation")
      .html(designation);
    $(".teamPopup")
      .children(".contentSection")
      .children(".inner")
      .children(".contentBlock")
      .children(".contact-location")
      .children(".location")
      .html(location);
    if (urlHref !== "") {
      $(".teamPopup")
        .children(".contentSection")
        .children(".inner")
        .children(".contentBlock")
        .children(".contact-location")
        .children(".url")
        .html(url);
      $(".teamPopup")
        .children(".contentSection")
        .children(".inner")
        .children(".contentBlock")
        .children(".contact-location")
        .children(".url")
        .show();
    } else {
      $(".teamPopup")
        .children(".contentSection")
        .children(".inner")
        .children(".contentBlock")
        .children(".contact-location")
        .children(".url")
        .hide();
    }
    $(".teamPopup")
      .children(".contentSection")
      .children(".inner")
      .children(".contentBlock")
      .children(".description")
      .html(description);
    $(".teamPopup").addClass("teamPopupOpen");
  });
  $(".closeIcon").click(function (e) {
    $(".teamPopup").removeClass("teamPopupOpen");
  });
  $(".three-column-team-section ul li").each(function () {
    // console.log("in Each ");
    var urlHref = $(this).children(".url").attr("href");
    if (urlHref == "") {
      $(this).children(".url").hide();
    }
  });
  /*Product usage accordian open*/
  try {
    $(".product-accordions__wrapper").each(function () {
      // console.log("in Each ");
      var accordionTitle = $(this)
        .children(".product-accordions__title-box")
        .children(".product-accordions__title")
        .html();
      if (accordionTitle.trim() == "Usage") {
        $(this)
          .children(".product-accordions__title-box")
          .addClass("product-accorionds__content-box--active");
        $(this).children(".product-accordions__content-box").slideDown();
      }
    });
  } catch (err) {}
});
/* 
HEADER
--by Junior
*/
var target = $(".mega-nav-list-title-link:contains('Shop By Color')")
  .parent()
  .parent();
target.find("a").each(function () {
  if (
    $(this).hasClass("mega-nav-list-title-link") ||
    $(this).text() == "All Colors"
  ) {} else {
    var colorText = $(this).text();
    var result = menuColors.filter((obj) => {
      return obj.name === colorText;
    });
    if (result[0]) {
      var newCircle =
        '<span class="mega-nav-color-circle" style="background:' +
        result[0].code +
        ';"></span>';
    }
    $(this).html(newCircle + colorText);
  }
});
/* PDP */
//alert("Is this running?");
$(".add-to-cart").val("Order a Sample Swatch");
$(".color-select-grid__button").each(function () {
  var handle = $(this).attr("href");
  if (!handle) {
    handle = $(this).attr("handle");
  }
  console.log(handle);
  if (handle.includes("/")) {
    handle = handle.split("/");
    handle = handle[2];
  }
  var result = library.filter((obj) => {
    return obj.handle === handle;
  });
  console.log(result);
  //console.log(result[0].specsColor );
  $(this).attr("style", "background-image:url(" + result[0].color + ");");
  var element = $(this);
  /* Get the Spec Color for the metafield - which is being used as a title for the anchor
  AJAX CALL */
  $.ajax({
      url: "/collections/all/products/" + handle + "?view=ajax",
      type: "GET",
      datatype: "json",
      cache: false,
    })
    .done(function (data) {
    
      var el = document.createElement("div");
      el.innerHTML = data;
   
      var options = JSON.parse(
        el.querySelector("[data-product-options]").innerHTML
         
      );
    //console.log(el.querySelector("[data-product-options]").innerHTML)
      //element.prop("title", options.product_settings.specsColor);
      element
        .children(".color-tooltip")
        .html(options.product_settings.specsColor +" - "+ options.product_settings.specFinish);
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.log("Error: " + errorThrown + "!");
      //element.prop("title", "Not Avaialble");
    });
});
/* PDP
Grab the Tag and build out a URL for the collections
*/

try{
var truecolor = $(".js-product-tag-truecolor").attr("data-attr-product-tag");
console.log("truecolor: " + truecolor);
truecolor = truecolor.replace(" ", "-");
if (truecolor != undefined) {
  //  truecolor = truecolor.split("-");
  // truecolor = truecolor.split(/-(.+)/)[1];
  console.log(truecolor);
  if (truecolor[1]) {
    /* $(".js-product-tag-truecolor a").attr(
      "href",
      "/collections/color-" + truecolor); */
    $(".js-product-tag-truecolor a").attr("href", "/collections/" + truecolor);
  } else {
    $(".js-product-tag-truecolor ").hide();
  }
}
}
catch{
  
}
/* PDP
Accordions
*/
$(".product-accordions__title-box").on("click", function () {
  var parent = $(this).parent();
  var target = parent.find(".product-accordions__content-box");
  var thisThing = $(this);
  if (target.is(":visible")) {
    target.slideUp();
    thisThing.removeClass("product-accorionds__content-box--active");
  } else {
    target.slideDown();
    thisThing.addClass("product-accorionds__content-box--active");
  }
});
/* PDP
Go through each accordion and check if there is some content inside it, if it's not there then hide the accordion 
This function is maily used for the "Usage" accordion as by default it has content in the field with all "false" values if nothing is checked in metafields
*/
$(".product-accordions__wrapper").each(function (index) {
  if (
    $(this)
    .children(".product-accordions__content-box")
    .children(".product-accordions__content")
    .html()
    .trim().length == 0
  ) {
    $(this).hide();
  }
});
/*
BLOG
Make the left section sticky on scroll */
$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  /*Checking scroll and added fixed header class in header*/
  if (scroll > 150) {
    $(".js-blog-sidebar").addClass("fixed-sidebar");
  } else {
    $(".js-blog-sidebar").removeClass("fixed-sidebar");
  }
});
/* Custom Collection Working */
function loadCustomCollection() {
  try {
 

  var schemaCustomProductString = $("#js-collection-product-handles").attr("data-handles").split(",");
  for (var j = 0; j < schemaCustomProductString.length; j++) {
    //         console.log($.trim(schemaCustomProductString[j]));
    let customString = $.trim(schemaCustomProductString[j]);
    customString = customString.split("|");
    let customHandle = customString[0];
    customHandle = customHandle.toLowerCase();
    let customMainImage = customString[1].split("~")[0];
    let customHoverImage = customString[1].split("~")[1];
    //         console.log(customHandle);
    //         console.log(customMainImage);
    /*
    1. loop through prodlibrary object
    2. Check if the handle of the schemaCustomProduct = AllProductHandle
    3. If its a YES; then show the article
    */
    $.each(prodLibrary, function (key, value) {
      //console.log(value.handle)
      if (customHandle == value.handle) {
        let title = value.title;
        title = title.split("|");
        let hoverImage = value.media;
        if (customHoverImage.indexOf("no-image") > -1) {
          hoverImage = hoverImage[0].image;
        } else {
          hoverImage = customHoverImage;
        }
        let url = value.url;
        let id = value.id;
        $('#js-collection-product-handles').append('<article class="product-list-item" id="product-list-item-' + id + '" data-product-id="' + id + '">' +
          '<figure class=" product-list-item-thumbnail has-secondary-image"' +
          'data-url="' + url + '" ' +
          'data-rimg="loaded" data-rimg-scale="1" ' +
          'data-rimg-template="' + hoverImage + '_{size}.png?v=1615983518" ' +
          'data-rimg-max="1200x792" data-rimg-crop="false" style="background-image: url(&quot;' + hoverImage + '&quot;);">' +
          '<a href="' + url + '"> ' +
          '<noscript data-rimg-noscript=""> ' +
          '<img src="' + customMainImage + '" alt="" data-rimg="noscript" srcset="' + customMainImage + ' 1x" >' +
          '</noscript> ' +
          '<img src="' + customMainImage + '" alt="" data-rimg="loaded" data-rimg-scale="1" data-rimg-template="' + customMainImage + '_{size}.png?v=1615983518" data-rimg-max="301x300" data-rimg-crop="false" srcset="' + customMainImage + '" > ' +
          '</a> </figure>' +
          '<div class="product-list-item-details">' +
          '<h2 class="product-list-item-title"><a href="' + url + '">' + title + ' </a></h2> </div> </article>');
      }
    });
  }
}
  
catch(err) {
 
}
}
// alert(prodLibrary[0]["handle"]);


